export const ADJ_LIST = [
  '선명한',
  '빠른',
  '조용한',
  '날카로운',
  '부드러운',
  '가벼운',
  '심심한',
  '단단한',
  '민첩한',
  '영리한',
  '창의적인',
  '신비한',
  '세련된',
  '현명한',
  '은은한',
  '고요한',
  '졸린',
];
export const NOUN_LIST = [
  '독수리',
  '고양이',
  '강아지',
  '토끼',
  '갈매기',
  '여우',
  '고슴도치',
  '다람쥐',
  '오징어',
  '바다거북',
  '돌고래',
  '문어',
  '호랑이',
  '부엉이',
  '코끼리',
];
